export const BASE_URL_MEET =
  typeof window !== 'undefined' ? window?.origin : process.env.MEET_ENDPOINT
